/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientCompany
 */
export interface ClientCompany {
    /**
     * 
     * @type {string}
     * @memberof ClientCompany
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompany
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompany
     */
    logoUrl?: string;
}

/**
 * Check if a given object implements the ClientCompany interface.
 */
export function instanceOfClientCompany(value: object): value is ClientCompany {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ClientCompanyFromJSON(json: any): ClientCompany {
    return ClientCompanyFromJSONTyped(json, false);
}

export function ClientCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompany {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
    };
}

export function ClientCompanyToJSON(value?: ClientCompany | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'logoUrl': value['logoUrl'],
    };
}

